var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('b-card-title', [_vm._v("METADATA")]), _c('b-table-simple', {
    attrs: {
      "small": ""
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "250px"
    }
  }), _c('col')]), _c('b-tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Aangemaakt op")]), _c('b-td', [_vm._v(_vm._s(_vm._f("datetime")(_vm.goodsReceipt.created_at)))])], 1), _c('b-tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Identifier")]), _c('b-td', [_vm._v(_vm._s(_vm.goodsReceipt.identifier))])], 1), _c('b-tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Leverancier")]), _c('b-td', [_c('location-link', {
    attrs: {
      "location": _vm.goodsReceipt.supplier_location
    }
  })], 1)], 1), _c('b-tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Ontvanger")]), _c('b-td', [_c('location-link', {
    attrs: {
      "location": _vm.goodsReceipt.recipient_location
    }
  })], 1)], 1), _c('b-tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Voltooid")]), _c('b-td', [_vm._v(" " + _vm._s(_vm.goodsReceipt.is_completed ? 'Ja' : 'Nee') + " ")])], 1)], 1)], 1)], 1), !_vm.goodsReceipt.is_completed ? _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [this.hasPermission('orders.batch.process.sort') ? _c('b-button', {
    staticClass: "bg-midnight-bloom text-white",
    attrs: {
      "disabled": _vm.isSaving || _vm.goodsReceipt.is_completed,
      "to": _vm.getScanRoute()
    }
  }, [_vm._v(" Start met scannen ")]) : _vm._e(), _c('br'), this.hasPermission('orders.batch.process.sort') ? _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "disabled": _vm.isSaving || _vm.goodsReceipt.is_completed,
      "variant": "info"
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show('confirmPostProcess');
      }
    }
  }, [!_vm.isSaving ? _c('span', [_vm._v("Klaar met scannen")]) : _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', [_c('b-card', [_c('b-card-title', [_vm._v("PRODUCTEN")]), _c('b-table', {
    attrs: {
      "fields": _vm.productFields,
      "items": _vm.goodsReceipt.lines,
      "small": ""
    },
    scopedSlots: _vm._u([{
      key: "table-colgroup",
      fn: function () {
        return [_c('col', {
          staticStyle: {
            "width": "130px"
          }
        }), _c('col', {}), _c('col', {
          staticStyle: {
            "width": "200px"
          }
        }), _c('col', {
          staticStyle: {
            "width": "200px"
          }
        }), _c('col', {
          staticStyle: {
            "width": "150px"
          }
        }), _c('col', {
          staticStyle: {
            "width": "150px"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(product_identifier)",
      fn: function (data) {
        var _data$item$metadata$p, _data$item$metadata, _data$item$metadata$p2, _data$item$metadata$p3, _data$item$metadata2, _data$item$metadata2$, _data$item$metadata2$2;
        return [_c('product-number', {
          attrs: {
            "number": data.value,
            "product-name": (_data$item$metadata$p = (_data$item$metadata = data.item.metadata) === null || _data$item$metadata === void 0 ? void 0 : (_data$item$metadata$p2 = _data$item$metadata.pim_data) === null || _data$item$metadata$p2 === void 0 ? void 0 : (_data$item$metadata$p3 = _data$item$metadata$p2.attributes) === null || _data$item$metadata$p3 === void 0 ? void 0 : _data$item$metadata$p3.productnaam_logistiek) !== null && _data$item$metadata$p !== void 0 ? _data$item$metadata$p : (_data$item$metadata2 = data.item.metadata) === null || _data$item$metadata2 === void 0 ? void 0 : (_data$item$metadata2$ = _data$item$metadata2.pim_data) === null || _data$item$metadata2$ === void 0 ? void 0 : (_data$item$metadata2$2 = _data$item$metadata2$.attributes) === null || _data$item$metadata2$2 === void 0 ? void 0 : _data$item$metadata2$2.product_naam
          }
        })];
      }
    }, {
      key: "cell(product_name)",
      fn: function (data) {
        var _ref, _data$item$metadata$p4, _data$item$metadata3, _data$item$metadata3$, _data$item$metadata3$2, _data$item$metadata4, _data$item$metadata4$, _data$item$metadata4$2;
        return [_vm._v(" " + _vm._s((_ref = (_data$item$metadata$p4 = (_data$item$metadata3 = data.item.metadata) === null || _data$item$metadata3 === void 0 ? void 0 : (_data$item$metadata3$ = _data$item$metadata3.pim_data) === null || _data$item$metadata3$ === void 0 ? void 0 : (_data$item$metadata3$2 = _data$item$metadata3$.attributes) === null || _data$item$metadata3$2 === void 0 ? void 0 : _data$item$metadata3$2.productnaam_logistiek) !== null && _data$item$metadata$p4 !== void 0 ? _data$item$metadata$p4 : (_data$item$metadata4 = data.item.metadata) === null || _data$item$metadata4 === void 0 ? void 0 : (_data$item$metadata4$ = _data$item$metadata4.pim_data) === null || _data$item$metadata4$ === void 0 ? void 0 : (_data$item$metadata4$2 = _data$item$metadata4$.attributes) === null || _data$item$metadata4$2 === void 0 ? void 0 : _data$item$metadata4$2.product_naam) !== null && _ref !== void 0 ? _ref : '') + " ")];
      }
    }, {
      key: "cell(is_bio)",
      fn: function (data) {
        var _data$item$metadata5, _data$item$metadata5$, _data$item$metadata5$2;
        return [_vm._v(" " + _vm._s((_data$item$metadata5 = data.item.metadata) !== null && _data$item$metadata5 !== void 0 && (_data$item$metadata5$ = _data$item$metadata5.pim_data) !== null && _data$item$metadata5$ !== void 0 && (_data$item$metadata5$2 = _data$item$metadata5$.attributes) !== null && _data$item$metadata5$2 !== void 0 && _data$item$metadata5$2.is_biologisch ? 'Ja' : 'Nee') + " ")];
      }
    }])
  })], 1)], 1)], 1), _vm.unprocessedDispatchRequests.length ? _c('b-row', [_c('b-col', [_c('b-card', [_c('b-card-title', [_vm._v("LEVERINGEN MET ONVERWERKTE PRODUCTEN")]), _vm._l(_vm.unprocessedDispatchRequestsByOrder, function (dispatchRequests, orderId) {
    return _c('div', {
      key: orderId
    }, [_c('h5', [_vm._v(" " + _vm._s(dispatchRequests[0].sales_order.identifier) + " "), _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: orderId,
        expression: "orderId"
      }],
      attrs: {
        "variant": "link"
      }
    }, [_c('font-awesome-icon', {
      staticClass: "when-closed",
      attrs: {
        "icon": "caret-down"
      }
    }), _c('font-awesome-icon', {
      staticClass: "when-open",
      attrs: {
        "icon": "caret-up"
      }
    })], 1)], 1), _c('b-collapse', {
      attrs: {
        "id": orderId
      }
    }, [_c('b-link', {
      attrs: {
        "to": _vm.orderLink(dispatchRequests[0].sales_order.identifier),
        "target": "_blank"
      }
    }, [_vm._v("Ga naar order")]), _c('dispatch-requests', {
      attrs: {
        "dispatch-requests": dispatchRequests,
        "sales-order": dispatchRequests[0].sales_order
      }
    })], 1)], 1);
  })], 2)], 1)], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "confirmPostProcess",
      "title": "Klaar met scannen",
      "cancel-title": "Annuleren",
      "ok-title": "Doorgaan",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.postProcess
    }
  }, [_vm._v(" Weet je zeker dat je deze goederenontvangst wilt afronden?"), _c('br'), _vm._v(" Alle niet-gescande producten zullen bij hun orders opnieuw worden toegewezen aan een nieuwe crossdock-levering. ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }